/*jshint globalstrict: false*/
export default {
    methods: {
        sendGaEvent(category, action, value) {
            try {
                gtag('event', action, {
                    'event_category': category,
                    'event_value': value
                });
            } catch (err) {
                try {
                    gtag('event', 'exception', {
                        'description': err,
                        'fatal': false
                    });
                } catch (err) {
                    console.error(err);
                }
            }
        },
        sendOrderEvent(category, cents) {
            let dollars = null;
            if (cents) {
                dollars = (cents * 0.01).toFixed(2);
            }
            this.sendGaEvent(category, 'order', dollars)
        },
        sendSignupEvent(category) {
            this.sendGaEvent(category, 'sign up', null)
        }
    }
};
